<template>
  <div class="start-grading-container">
    <section class="p-0 section-items">
      <eg-b-row class="start-grading-header mb-2">
        <eg-b-col cols="12">
          <h1>{{ $t("common.startGrading") }}</h1>
          <folder-breadcrumbs
            v-if="currentFolder"
            :folder-parent-id="currentFolder.parentId"
            :folder-name="currentFolder.name"
            class="my-2"
          />
        </eg-b-col>
      </eg-b-row>
      <eg-b-row>
        <eg-b-col cols="12">
          <slot />
        </eg-b-col>
      </eg-b-row>
    </section>
  </div>
</template>

<script>
import FolderBreadcrumbs from "@/components/folders/folder_breadcrumbs.vue";

export default {
  name: "StartGradingContainer",

  components: {
    FolderBreadcrumbs,
  },

  inject: ["workspacesProvider"],

  props: {
    to: {
      type: String,
      default: "",
    },
  },

  computed: {
    folderId() {
      return this.$route.params.id;
    },

    currentFolder() {
      return this.workspacesProvider.getFolderById(
        this.$route.params.workspaceKey,
        this.folderId
      );
    },
  },
};
</script>
<style scoped lang="scss">
.start-grading-container {
  padding: 0px;
  margin: 0 auto 50px auto;
  max-width: 960px;
  font-family: Inter;
  h1 {
    margin: 0;
    color: var(--color-text-neutral-on-white, #1c0f30);
    font-family: var(--typography-font-family-text-primary, Inter);
    font-size: var(--typography-font-size-fs-700, 24px);
    font-style: normal;
    font-weight: var(--typography-font-weight-fw-600, 600);
    line-height: 120%;
  }
}
.go-back-link:not(.disabled) {
  background: transparent;
  border: none;
  outline: none;
  &:focus,
  &:active:focus,
  &:hover,
  &:active {
    background: transparent;
    border: none;
    outline: none;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem var(--purple-100);
  }
}

.section-items {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .subtitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #1c0f30;
  }
}
</style>
